import { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import "./TechSheet.css";

/**
 * TicketSheet — overlay quasi a piena pagina in stile "Torna a casa".
 * Il biglietto SALE veloce dal basso all'apertura e SCENDE alla chiusura.
 * Sfondo sfocato, scrollabile, si chiude solo con la X in alto.
 */
export default function TicketSheet({ open, onClose, children, testId, z = 110 }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="tks-layer"
          style={{ zIndex: z }}
          data-testid={testId}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
        >
          <button className="tks-x" onClick={onClose} aria-label="Chiudi" data-testid="ticket-sheet-close">
            <X className="w-5 h-5" strokeWidth={2.4} />
          </button>
          <div className="tks-scroll">
            <motion.div
              className="tks-wrap"
              initial={{ y: "100%", opacity: 0.5 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: "110%", opacity: 0.4 }}
              transition={{ type: "spring", stiffness: 380, damping: 34, mass: 0.7 }}
            >
              {children}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
